module.exports = __webpack_public_path__ + "static/media/3.10.88a1cef0.png";